const isString = value => typeof value === 'string';

const normalizeWhitespace = value =>
  value.replace(/\s+/g, ' ').trim();

export const trimText = value => (isString(value) ? value.trim() : value);

export const squishText = value =>
  isString(value) ? normalizeWhitespace(value) : value;

export const downcaseText = value =>
  isString(value) ? value.toLowerCase() : value;

export const normalizeOptionalText = (value, { squish = false } = {}) => {
  const normalized = squish ? squishText(value) : trimText(value);
  return normalized === '' ? null : normalized;
};

export const normalizeIdentifier = (value, { squish = false } = {}) => {
  const normalized = squish ? squishText(value) : trimText(value);
  return downcaseText(normalized);
};

export const normalizeStringArray = (
  values,
  { squish = false, downcase = false, dedupe = true } = {}
) => {
  if (!Array.isArray(values)) {
    return [];
  }

  const seen = new Set();
  const normalized = [];

  values.forEach(item => {
    if (!isString(item)) return;

    let sanitizedItem = squish ? squishText(item) : trimText(item);
    if (!sanitizedItem) return;

    if (downcase) {
      sanitizedItem = sanitizedItem.toLowerCase();
    }

    const dedupeKey = downcase ? sanitizedItem : sanitizedItem.toLowerCase();
    if (dedupe && seen.has(dedupeKey)) return;

    seen.add(dedupeKey);
    normalized.push(sanitizedItem);
  });

  return normalized;
};

export const sanitizeCommaSeparatedText = value =>
  normalizeStringArray(String(value || '').split(','), {
    squish: true,
    downcase: false,
    dedupe: true,
  });

